let dragItem;
let addToEvent;
const events = {
  onDragStart: (e, item, addEvent) => {
    dragItem = item;
    addToEvent = addEvent;
    e.target.classList.add('dragging');
  },
  onDragOver: e => {
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.dataTransfer.dropEffect = 'copy';
    return false;
  },
  onDragEnter: e => {
    const { target } = e;
    target.classList.add('over');
  },
  onDragLeave: e => {
    const { target } = e;
    target.classList.remove('over');
  },
  onDrop: inE => {
    let e = inE;
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    addToEvent(dragItem, {
      dragenter: 'true',
      left: e.layerX,
      top: e.layerY
    });
    return false;
  },
  onDragEnd: e => {
    dragItem = null;
    e.target.classList.remove('dragging');
  }
};

export default events;
